import { LucideIcon, Inbox } from 'lucide-react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  compact?: boolean;
  className?: string;
}

export function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  actionLabel,
  onAction,
  compact = false,
  className = ''
}: EmptyStateProps) {
  const content = (
    <div className={`text-center ${compact ? 'py-8' : 'py-12'}`}>
      <div className={`inline-flex items-center justify-center ${compact ? 'w-16 h-16' : 'w-20 h-20'} rounded-full bg-muted mb-4`}>
        <Icon className={`${compact ? 'h-8 w-8' : 'h-10 w-10'} text-muted-foreground`} />
      </div>
      <h3 className="mb-2">{title}</h3>
      {description && (
        <p className="text-muted-foreground mb-4 max-w-md mx-auto">
          {description}
        </p>
      )}
      {actionLabel && onAction && (
        <Button onClick={onAction} variant="default">
          {actionLabel}
        </Button>
      )}
    </div>
  );

  if (compact) {
    return <div className={className}>{content}</div>;
  }

  return (
    <Card className={className}>
      {content}
    </Card>
  );
}
